module.exports = __webpack_public_path__ + "img/swiper.1df58e4.png";